import { useGetUserQuery } from '@/api/piloteer';
import { useAppSelector } from '@/store/hooks';
import NotFound from '@/ui/pages/not-found';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { FullPageLoading } from '../feedback/loading/full-page-loading';
import { resolveSuperAdminAccess } from './super-admin-access';

interface SuperAdminRouteProps {
  children: ReactNode;
}

/** Gate platform-admin pages using the authenticated user's API capability. */
export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const { pathname } = useLocation();
  const { session, isLoading: isAuthLoading } = useAppSelector(
    (state) => state.auth
  );
  const {
    data: user,
    isLoading: isUserLoading,
    isError: hasUserError,
  } = useGetUserQuery(undefined, { skip: !session });
  const access = resolveSuperAdminAccess({
    hasSession: Boolean(session),
    isAuthLoading,
    isUserLoading,
    hasUserError,
    canAccessPlatformAdmin: Boolean(user?.canAccessPlatformAdmin),
    platformRole: user?.platformRole,
    pathname,
  });

  if (access === 'loading') return <FullPageLoading />;
  if (access === 'notFound') return <NotFound />;

  return <>{children}</>;
}
